<template>
  <div>
    <div id="videoPlayer" style="width: 100%; height: 400px" class="video-js videoBox" muted @contextmenu.prevent="handleContextMenu"></div>

    <div class="videoNme">
      <div class="name">{{ videoInfo.cwName }}</div>
      <div class="hangye">所属课程：{{ courseName }}</div>
    </div>

    <div class="tab">
      <div :class="tabIndex == '1' ? 'tablan active' : 'tablan'" @click="tabIndex = 1">课程章节</div>
      <div :class="tabIndex == '2' ? 'tablan active' : 'tablan'" @click="tabIndex = 2">温馨提示</div>
    </div>

    <div v-if="tabIndex == '1'" class="chaper">
      <div class="zjBox" v-for="(item, index) in chapterList" :key="item.chapterId" @click="playChapter(item)">
        <div :class="videoInfo.chapterId == item.chapterId ? 'chName activeColor' : 'chName'">
          {{ item.cwName }}
        </div>

        <div class="xsOrBtn">
          <div class="xs"></div>
          <div class="btn activeBtn" v-if="videoInfo.chapterId == item.chapterId">正在播放</div>
          <div class="btn" v-else >播放</div>
        </div>
      </div>
    </div>

    <div v-if="tabIndex == '2'" class="wxts">
      <div>1.学习前务必填写完整的个人信息，否则无法登记学时证明；</div>
      <div>2.如果视频无法播放，推荐使用QQ浏览器；</div>
      <div>3.课程通过后可自主打印学时证明；</div>
      <div>4.如您需要发票请到缴费订单管理界面申领电子发票。</div>
    </div>
  </div>
</template>

<script>
import HlsPlugin from 'xgplayer-hls';
import Player from 'xgplayer';
import { toCourseDetail } from '../../api/vip';
import { toVideoUrl } from '../../api/myClass';
export default {
  data() {
    return {
      tabIndex: 1,
      player: null,
      chapterList: [],
      videoInfo: {},
      courseName: '',
      queryPams: {},
      courseId:''
    };
  },
  created() {
    this.courseName = this.$route.query.courseName;
    this.queryPams.courseId = this.$route.query.courseId;
    this.queryPams.coursewareId = this.$route.query.courseWareId;

    this.getData();
  },
  methods: {
    toVideoUrl(courseId, chapterId) {
      let data = {
        courseId: courseId,
        chapterId: chapterId
      };
      toVideoUrl(data).then(res => {
        this.getVideo(res.data.data);
      });
    },
    getData() {
      toCourseDetail(this.queryPams).then(res => {
        this.chapterList = res.data.data.chapterList;
        this.videoInfo = this.chapterList[0];
        this.courseId=res.data.data.course.id
        this.toVideoUrl(res.data.data.course.id, this.chapterList[0].chapterId);
        // this.getVideo(this.videoInfo);
      });
    },

    playChapter(chapter) {
      console.log(chapter,'999');
      this.videoInfo = chapter;
      this.toVideoUrl(this.courseId,chapter.chapterId);
    },
    getVideo(videoData) {
      // 销毁已有播放器
      if (this.player) {
        this.player.destroy();
      }
      const videoUrl = videoData.LAUNCH;
      if (videoUrl.isZjw == '1' || videoUrl.isYlx == '1') {
        this.player = new Player({
          id: 'videoPlayer',
          autoplay: true,
          playsinline: true,
          url: videoUrl.LAUNCH,
          progressDisabled: true
        });
      } else {
      if (/\.m3u8$/.test(videoUrl)) {
        this.player = new Player({
          id: 'videoPlayer',
          url: videoUrl,
          autoplay: true,
          playsinline: true,
          plugins: [HlsPlugin] // 第二步
        });
      } else {
        this.player = new Player({
          el: document.getElementById('videoPlayer'),
          url: `${videoUrl}.mp4`,
          autoplay: true,
          playsinline: true
        });
      }}

      this.player.play();
      // 监听视频结束事件
      this.player.once('ended', () => {
        this.playNextVideo();
      });

      // 实时更新进度
      setInterval(() => {
        if (this.player && !this.player.ended()) {
          let progress = Math.min(100, Math.round((this.player.currentTime / this.player.duration) * 100));
          this.videoInfo.jinDu = progress;
        }
      }, 10000);
    },

    playNextVideo() {
      const currentIndex = this.chapterList.findIndex(chap => chap.chapterId === this.videoInfo.chapterId);
      if (currentIndex >= 0 && currentIndex < this.chapterList.length - 1) {
        const nextChapter = this.chapterList[currentIndex + 1];
        this.playChapter(nextChapter);
      }
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  }
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#videoPlayer {
  margin-top: 50px;
  width: 100% !important;
  height: 211px !important;
}
.videoNme {
  width: 100%;
  height: 84px;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 20px 15px;
  .name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 16px;
  }
  .hangye {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    margin-top: 7px;
    font-size: 13px;
  }
}

.tab {
  display: flex;
  margin-top: 28px;
  padding: 0 15px;
  .tablan {
    position: relative;
    margin-right: 26px;
    font-size: 15px;
    color: #333;
    .bor {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 64px;
      height: 5px;
      background: linear-gradient(90deg, #2a70f2 0%, rgba(42, 112, 242, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
  .active {
    font-size: 16px;
    font-weight: 600;
  }
}

.chaper {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  min-height: 498px;
  padding: 15px;
  .zjBox {
    display: flex;
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        margin-top: 4px;
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
}

.wxts {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  padding: 20px 15px;
  color: #666666;
  font-size: 13px;
  line-height: 25px;
}
</style>
